import React, { useState } from 'react';
import { ModuleBase, Stack, Text, Box, Link } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';
import classNames from 'classnames';
import { accordionPanel, fadeInLeft, fadeInRight } from '@/animations';
import Collapse from '@/assets/collapse.svg';
import Expand from '@/assets/expand.svg';
import { motion } from 'motion/react';

const AdvisoryEnergise = (data: SideBySideModuleModel) => {
  const {
    props: { alignment, link1, title, description, preTitle, cards },
  } = data;

  const [expandedIndex, setExpandedIndex] = useState<number>(-1);

  const _setExpandedIndex = (index: number) => {
    if (expandedIndex === index) {
      setExpandedIndex(-1);
    } else {
      setExpandedIndex(index);
    }
  };

  return (
    <ModuleBase
      data={{ ...data, props: { ...data.props, backgroundColour: alignment === 'Right' ? '#f1f0e9' : '#fff' } }}
      noPadding
      className="AdvisoryEnergise overflow-hidden py-10 lg:py-18"
    >
      <Stack
        className={classNames(
          'container flex flex-col justify-between gap-8 lg:items-stretch lg:gap-0',
          alignment === 'Right' ? 'lg:flex-row-reverse' : 'lg:flex-row',
        )}
      >
        <div className="flex w-full flex-grow flex-col justify-between lg:w-1/2">
          <div>
            {preTitle && (
              <Text
                animation={alignment === 'Right' ? fadeInLeft : fadeInRight}
                className="text-style-tag mb-5 uppercase"
              >
                {preTitle}
              </Text>
            )}
            {title && (
              <Text
                animation={alignment === 'Right' ? fadeInLeft : fadeInRight}
                className="text-style-h3 mb-5 xl:w-[80%] [&_.largerText]:xl:text-[72px] [&_.largerText]:xl:leading-[75px]"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}

            {description && (
              <Text
                animation={alignment === 'Right' ? fadeInLeft : fadeInRight}
                className="text-style-h4 xl:mt-30 xl:w-[80%]"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
          </div>
          {link1 && <Link animate className="btn primary v2 mt-6 lg:mt-14" link={link1} />}
        </div>
        <div className="w-full flex-grow lg:w-1/2">
          <div className="h-full xl:px-9">
            {cards && (
              <div className="flex-col gap-5">
                {cards.map((card, index) => (
                  <Box
                    animation={alignment === 'Right' ? fadeInLeft : fadeInRight}
                    key={index}
                    className={classNames(
                      'flex flex-col border-black py-5 first:pt-0',
                      index !== 0 &&
                        (alignment === 'Right'
                          ? 'border-t lg:border-t lg:border-solid'
                          : 'lg:after-extended-line-top border-t lg:border-t-0'),
                    )}
                  >
                    <button
                      className="flex cursor-pointer items-center justify-between text-left"
                      onClick={() => _setExpandedIndex(index)}
                    >
                      <p className="text-style-h5">{card.title}</p>

                      <div className="btn icon secondary h-9 w-9 shrink-0 !border-black">
                        {expandedIndex === index ? (
                          <Collapse className="stroke-black" />
                        ) : (
                          <Expand className="stroke-black" />
                        )}
                      </div>
                    </button>
                    <motion.div
                      variants={accordionPanel.variants}
                      initial="inactive"
                      animate={expandedIndex === index ? 'active' : 'inactive'}
                      className="print:!h-auto print:!opacity-100"
                    >
                      {card.text && (
                        <div
                          className="text-style-body pt-2 lg:w-4/5 xl:w-11/12"
                          dangerouslySetInnerHTML={{ __html: card.text }}
                        />
                      )}
                    </motion.div>
                  </Box>
                ))}
              </div>
            )}
          </div>
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default AdvisoryEnergise;
